// Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyD1Caf3WW7RvrcWkF78E9KFfr689gozfho",
  authDomain: "northstonecu.firebaseapp.com",
  projectId: "northstonecu",
  storageBucket: "northstonecu.firebasestorage.app",
  messagingSenderId: "899780977431",
  appId: "1:899780977431:web:b6490e848260daa12f0d52"
}; 